document.addEventListener("DOMContentLoaded", async () => {
  if (window.location.search.indexOf('thankyou') > -1) {
      // If it does, create a new div
      var parentDiv = document.getElementById('header-navigation');
    
      var thankYouDiv = document.createElement('div');
  
      // Set the content of the div
      thankYouDiv.innerHTML = "<p>Thank you for your purchase! We'd appreciate it if you could leave a review.</p>";
  
      // Style the div to appear at the top of the screen
      thankYouDiv.style.position = 'relative';
      thankYouDiv.style.top = '0';
      thankYouDiv.style.left = '0';
      thankYouDiv.style.width = '100%';
      thankYouDiv.style.height = '2vh';
      thankYouDiv.style.padding = '10px';
      thankYouDiv.style.backgroundColor = '#f8d7da';
      thankYouDiv.style.color = '#721c24';
      thankYouDiv.style.textAlign = 'center';
  
      // Finally, add the div to the body of the document
      parentDiv.appendChild(thankYouDiv);
  }
});

